<template>
	<div>
		<div role="status" class="w-full animate-pulse">
			<div class="h-2 rounded-full bg-gray-disabled-variant max-w-[360px] mb-2.5"></div>
			<div class="h-2 rounded-full bg-gray-disabled-variant mb-2.5"></div>
			<div class="h-2 rounded-full bg-gray-disabled-variant max-w-[330px] mb-2.5"></div>
			<div class="h-2 rounded-full bg-gray-disabled-variant max-w-[300px] mb-2.5"></div>
			<div class="h-2 rounded-full bg-gray-disabled-variant max-w-[360px]"></div>
			<span class="sr-only">Loading...</span>
		</div>
	</div>
</template>

<script>
export default {
	name: "Paragraph",
}
</script>
